"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DraggableModalInner = void 0;

var _react = _interopRequireWildcard(require("react")),
    _antd = require("antd"),
    _ResizeHandle = require("./ResizeHandle"),
    _useDrag = require("./useDrag"),
    _usePrevious = require("./usePrevious"),
    _useResize = require("./useResize");

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

var modalStyle = {
  margin: 0,
  paddingBottom: 0,
  pointerEvents: "auto"
},
    DraggableModalInner = (0, _react.memo)(function (a) {
  var b = a.id,
      c = a.modalState,
      d = a.dispatch,
      e = a.visible,
      f = a.children,
      g = a.title,
      h = _objectWithoutProperties(a, ["id", "modalState", "dispatch", "visible", "children", "title"]);

  (0, _react.useEffect)(function () {
    return d({
      type: "mount",
      id: b
    }), function () {
      return d({
        type: "unmount",
        id: b
      });
    };
  }, [d, b]); // Bring this to the front if it's been opened with props.

  var i = (0, _usePrevious.usePrevious)(e);
  (0, _react.useEffect)(function () {
    e !== i && (e ? d({
      type: "show",
      id: b
    }) : d({
      type: "hide",
      id: b
    }));
  }, [e, i, b, d]);
  var j = c.zIndex,
      k = c.x,
      l = c.y,
      m = c.width,
      n = c.height,
      o = (0, _react.useMemo)(function () {
    return _objectSpread({}, modalStyle, {
      top: l,
      left: k,
      height: n
    });
  }, [l, k, n]),
      p = (0, _react.useCallback)(function () {
    return d({
      type: "focus",
      id: b
    });
  }, [b, d]),
      q = (0, _react.useCallback)(function (a) {
    return d(_objectSpread({
      type: "drag",
      id: b
    }, a));
  }, [d, b]),
      r = (0, _react.useCallback)(function (a) {
    return d(_objectSpread({
      type: "resize",
      id: b
    }, a));
  }, [d, b]),
      s = (0, _useDrag.useDrag)(k, l, q),
      t = (0, _useResize.useResize)(k, l, m, n, r),
      u = (0, _react.useMemo)(function () {
    return _react["default"].createElement("div", {
      className: "ant-design-draggable-modal-title",
      onMouseDown: s,
      onClick: p
    }, g);
  }, [s, p, g]);
  return _react["default"].createElement(_antd.Modal, _extends({
    wrapClassName: "ant-design-draggable-modal",
    style: o,
    width: m,
    destroyOnClose: !0,
    mask: h.mask || !1,
    maskClosable: h.maskClosable || !1,
    zIndex: j,
    title: u,
    visible: e
  }, h), _react["default"].createElement("div", {
    onClick: p
  }, f), _react["default"].createElement(_ResizeHandle.ResizeHandle, {
    onMouseDown: t
  }));
});
exports.DraggableModalInner = DraggableModalInner;